import { watch, type Ref } from 'vue'

export function useScrollLock(isLockedRef: Ref<boolean>) {
  watch(isLockedRef, locked => {
    const body = document.body
    if (locked) {
      body.style.overflow = 'hidden'
      body.style.touchAction = 'none'
    } else {
      body.style.overflow = ''
      body.style.touchAction = ''
    }
  })
}
